var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.024,
    height: 17.5,
    viewBox: "0 0 19.024 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "snapchat",
    transform: "translate(0.25 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M14.024,10.369l1.669-1.3a.762.762,0,0,0,.251-.838h0a.762.762,0,0,0-.861-.51l-1.173.259a.381.381,0,0,1-.442-.45C14.047,3.961,12.188,1.5,9.262,1.5S4.47,3.961,5.056,7.5a.381.381,0,0,1-.442.48L3.441,7.725a.762.762,0,0,0-.869.5h0a.762.762,0,0,0,.251.838l1.676,1.3a.381.381,0,0,1,.114.457A6.034,6.034,0,0,1,.5,14.071c.1,1.288,2.286.29,2.667.762a2.057,2.057,0,0,1,.381,1.143H5.071c1.143,0,2.522,1.524,4.19,1.524s3.048-1.524,4.19-1.524h1.524a2.057,2.057,0,0,1,.381-1.143c.381-.472,2.575.526,2.667-.762A6.034,6.034,0,0,1,13.9,10.826a.381.381,0,0,1,.122-.457Z",
    fill: "none",
    stroke: "#b07f4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapchat);
export default __webpack_public_path__ + "static/media/snapchat.5a8d434f5c6a752edcb06feffb4c2c0b.svg";
export { ForwardRef as ReactComponent };